import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import { Base_URL } from "../../apiConfig";
import { toast, ToastContainer } from "react-toastify";
import { htmlToText } from 'html-to-text';
import { useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';

const WishlistedColleges = () => {
  const [activeTab, setActiveTab] = useState('shortlists');
  const [applications, setApplications] = useState([]);
  const [shortlistedColleges, setShortlistedColleges] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedCollege, setSelectedCollege] = useState(null);
  const [courses, setCourses] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [applicationsLoading, setApplicationsLoading] = useState(true);
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
 

  useEffect(() => {
    const fetchApplications = async () => {
      setApplicationsLoading(true);
      try {
        const response = await axios.get(`${Base_URL}/apply-now`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setApplications(response.data || []);
      } catch (error) {
        console.error('Error fetching applications:', error);
        toast.error("Failed to fetch applications");
      } finally {
        setApplicationsLoading(false);
      }
    };

    if (activeTab === 'applications') {
    fetchApplications();
    }
  }, [token, activeTab]);


  useEffect(() => {
    const fetchShortlistedColleges = async () => {
      if (activeTab === 'shortlists' && token) {
        setLoading(true);
        try {
          const response = await axios.get(
            `${Base_URL}/student/university-shortlist`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setShortlistedColleges(response.data || []);
        } catch (error) {
          console.error('Error fetching shortlisted colleges:', error);
          toast.error("Failed to fetch shortlisted colleges");
        } finally {
          setLoading(false);
        }
      }
    };

    fetchShortlistedColleges();
  }, [activeTab, token]);

  const handleDetailClick = (college) => {
    const universityNameSlug = encodeURIComponent(
      college.university_name.trim().toLowerCase().replace(/\s+/g, "-")
    );
    navigate(`/college/${universityNameSlug}`);
  };
  const fetchCourses = async (universityId) => {
    try {
      const response = await axios.get(`${Base_URL}/course-master/all-by-university-id/${universityId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setCourses(response.data || []);
      console.log(response.data);
    } catch (error) {
      console.error('Error fetching courses:', error);
      toast.error("Failed to fetch courses");
    }
  };

  const handleApplyNowClick = (college) => {
    setSelectedCollege(college);
    fetchCourses(college.university_id);
    setModalOpen(true);
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(`${Base_URL}/apply-now`, {
        university_id: String(selectedCollege.university_id), 
        course_master_id: String(selectedCourse), 
      }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
  
      // Show toast first
      toast.success(response.data.message || "Application submitted successfully!");
      
      // Close modal after a short delay to ensure toast is visible
      setTimeout(() => {
        setModalOpen(false);
      }, 500); // 2 seconds delay
    } catch (error) {
      const errorMessage = error.response?.data?.message || "Failed to submit application";
      toast.error(errorMessage);
    }
  };

  // const fetchApplications = async () => {
  //   try {
  //     const response = await axios.get(`${Base_URL}/apply-now`, {
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });
  //     setApplications(response.data || []);
  //   } catch (error) {
  //     console.error('Error fetching applications:', error);
  //     toast.error("Failed to fetch applications");
  //   }
  // };

  return (
    <div className="w-full px-4 md:px-6 lg:px-8 py-6 max-w-[1440px] mx-auto">
      {/* Top Header Section */}
      <div className="w-full max-w-[400px] mx-auto border border-[#00000040] rounded-lg p-4 mb-6">
        <div className="flex justify-center items-center w-full">
          <div className="flex items-center space-x-4">
            {/* Shortlists Section */}
            <button 
              onClick={() => setActiveTab('shortlists')}
              className={`flex items-center space-x-3 ${activeTab === 'shortlists' ? 'text-[#3ACA2E] underline' : ''}`}
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.54112 3.94755C6.26943 2.67586 4.21207 2.66968 2.94588 3.93587C1.67969 5.20206 1.68587 7.25942 2.95756 8.53111L7.66505 13.2386C7.86031 13.4339 8.1769 13.4339 8.37216 13.2386L13.0552 8.55833C14.3184 7.28802 14.3144 5.23643 13.0425 3.96452C11.7686 2.69054 9.71024 2.68436 8.44178 3.95282L7.99452 4.40095L7.54112 3.94755Z" fill={activeTab === 'shortlists' ? "#3ACA2E" : "#000000"}/>
              </svg>
              <span className="text-sm font-semibold">Shortlists</span>
            </button>

            {/* Applications Section */}
            <button 
              onClick={() => setActiveTab('applications')}
              className={`flex items-center space-x-3 ${activeTab === 'applications' ? 'text-[#3ACA2E] underline' : ''}`}
            >
              <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2658_19238)">
<path d="M13.3592 3.6808C13.5155 3.83705 13.6494 4.04911 13.761 4.31696C13.8726 4.58482 13.9284 4.83036 13.9284 5.05357V14.6964C13.9284 14.9196 13.8503 15.1094 13.6941 15.2656C13.5378 15.4219 13.3481 15.5 13.1249 15.5H1.87486C1.65165 15.5 1.46191 15.4219 1.30566 15.2656C1.14941 15.1094 1.07129 14.9196 1.07129 14.6964V1.30357C1.07129 1.08036 1.14941 0.890625 1.30566 0.734375C1.46191 0.578125 1.65165 0.5 1.87486 0.5H9.37486C9.59807 0.5 9.84361 0.555804 10.1115 0.667411C10.3793 0.779018 10.5914 0.912946 10.7476 1.0692L13.3592 3.6808ZM9.64272 1.63839V4.78571H12.79C12.7342 4.62388 12.6729 4.50949 12.6059 4.44252L9.98591 1.82254C9.91895 1.75558 9.80455 1.6942 9.64272 1.63839ZM12.857 14.4286V5.85714H9.37486C9.15165 5.85714 8.96191 5.77902 8.80566 5.62277C8.64941 5.46652 8.57129 5.27679 8.57129 5.05357V1.57143H2.14272V14.4286H12.857ZM4.28557 7.19643C4.28557 7.1183 4.31069 7.05413 4.36091 7.00391C4.41113 6.95368 4.47531 6.92857 4.55343 6.92857H10.4463C10.5244 6.92857 10.5886 6.95368 10.6388 7.00391C10.689 7.05413 10.7141 7.1183 10.7141 7.19643V7.73214C10.7141 7.81027 10.689 7.87444 10.6388 7.92466C10.5886 7.97489 10.5244 8 10.4463 8H4.55343C4.47531 8 4.41113 7.97489 4.36091 7.92466C4.31069 7.87444 4.28557 7.81027 4.28557 7.73214V7.19643C4.28557 7.12388 4.31069 7.0611 4.36091 7.00809C4.41113 6.95508 4.47531 6.92857 4.55343 6.92857H10.4463ZM10.4463 9.07143C10.5244 9.07143 10.5886 9.09654 10.6388 9.14676C10.689 9.19699 10.7141 9.26116 10.7141 9.33929V9.875C10.7141 9.95312 10.689 10.0173 10.6388 10.0675C10.5886 10.1177 10.5244 10.1429 10.4463 10.1429H4.55343C4.47531 10.1429 4.41113 10.1177 4.36091 10.0675C4.31069 10.0173 4.28557 9.95312 4.28557 9.875V9.33929C4.28557 9.26116 4.31069 9.19699 4.36091 9.14676C4.41113 9.09654 4.47531 9.07143 4.55343 9.07143H10.4463ZM10.4463 11.2143C10.5244 11.2143 10.5886 11.2394 10.6388 11.2896C10.689 11.3398 10.7141 11.404 10.7141 11.4821V12.0179C10.7141 12.096 10.689 12.1602 10.6388 12.2104C10.5886 12.2606 10.5244 12.2857 10.4463 12.2857H4.55343C4.47531 12.2857 4.41113 12.2606 4.36091 12.2104C4.31069 12.1602 4.28557 12.096 4.28557 12.0179V11.4821C4.28557 11.404 4.31069 11.3398 4.36091 11.2896C4.41113 11.2394 4.47531 11.2143 4.55343 11.2143H10.4463Z" fill={activeTab === 'applications' ? "#3ACA2E" : "#000000"}/>
</g>
<defs>
<clipPath id="clip0_2658_19238">
<rect width="15" height="15" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
</svg>

              <span className="text-sm font-semibold">Track your applications</span>
            </button>
          </div>
        </div>
      </div>

      {activeTab === 'shortlists' ? (
        loading ? (
          <div className="flex justify-center items-center h-64">
            <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#3ACA2E]"></div>
          </div>
        ) : (
          
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-[1040px] mx-auto">
              {shortlistedColleges.map((college, index) => (
            <div key={index} className="w-full h-[300px] border border-[#00000040] rounded-lg flex flex-col">
              <div className="flex-1 p-6 space-y-4">
                <h2 className="text-[18px]   font-semibold leading-[28.64px]">
  {college.university_name || 'Lorem Ipsum'}
                </h2>
                {/* <p className="text-[12px] font-medium text-[#A1A1A1] leading-[15.62px]">
  {college.main_intro || 'Lorem ipsum odor amet, consectetuer adipiscing elit.'}
                </p> */}
              <p className="text-[10px]  xl:text-sm lg:text-[18px] text-black line-clamp-5 ">
    {htmlToText(college.sub_intro || 'Lorem ipsum odor amet, consectetuer adipiscing elit. Risus tortor fames rutrum fringilla sociosqu.')}
                </p>

                <div className="border border-[#00000040] mt-auto">
                  <div className="flex justify-between items-center">
                    <button onClick={() => handleDetailClick(college)}  className="flex-1 flex items-center justify-center space-x-2 py-3 border-r border-[#00000040]">
                        <svg width="15" height="15" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2658_19252)">
<path d="M4.82146 11.4821V12.0179C4.82146 12.0904 4.79496 12.1532 4.74194 12.2062C4.68893 12.2592 4.62615 12.2857 4.55361 12.2857H4.01789C3.94535 12.2857 3.88257 12.2592 3.82955 12.2062C3.77654 12.1532 3.75003 12.0904 3.75003 12.0179V11.4821C3.75003 11.4096 3.77654 11.3468 3.82955 11.2938C3.88257 11.2408 3.94535 11.2143 4.01789 11.2143H4.55361C4.62615 11.2143 4.68893 11.2408 4.74194 11.2938C4.79496 11.3468 4.82146 11.4096 4.82146 11.4821ZM4.82146 9.33929V9.875C4.82146 9.94754 4.79496 10.0103 4.74194 10.0633C4.68893 10.1164 4.62615 10.1429 4.55361 10.1429H4.01789C3.94535 10.1429 3.88257 10.1164 3.82955 10.0633C3.77654 10.0103 3.75003 9.94754 3.75003 9.875V9.33929C3.75003 9.26674 3.77654 9.20396 3.82955 9.15095C3.88257 9.09793 3.94535 9.07143 4.01789 9.07143H4.55361C4.62615 9.07143 4.68893 9.09793 4.74194 9.15095C4.79496 9.20396 4.82146 9.26674 4.82146 9.33929ZM6.96432 9.33929V9.875C6.96432 9.94754 6.93781 10.0103 6.8848 10.0633C6.83179 10.1164 6.76901 10.1429 6.69646 10.1429H6.16075C6.0882 10.1429 6.02542 10.1164 5.97241 10.0633C5.9194 10.0103 5.89289 9.94754 5.89289 9.875V9.33929C5.89289 9.26674 5.9194 9.20396 5.97241 9.15095C6.02542 9.09793 6.0882 9.07143 6.16075 9.07143H6.69646C6.76901 9.07143 6.83179 9.09793 6.8848 9.15095C6.93781 9.20396 6.96432 9.26674 6.96432 9.33929ZM4.82146 7.19643V7.73214C4.82146 7.80469 4.79496 7.86747 4.74194 7.92048C4.68893 7.97349 4.62615 8 4.55361 8H4.01789C3.94535 8 3.88257 7.97349 3.82955 7.92048C3.77654 7.86747 3.75003 7.80469 3.75003 7.73214V7.19643C3.75003 7.12388 3.77654 7.0611 3.82955 7.00809C3.88257 6.95508 3.94535 6.92857 4.01789 6.92857H4.55361C4.62615 6.92857 4.68893 6.95508 4.74194 7.00809C4.79496 7.0611 4.82146 7.12388 4.82146 7.19643ZM11.25 11.4821V12.0179C11.25 12.0904 11.2235 12.1532 11.1705 12.2062C11.1175 12.2592 11.0547 12.2857 10.9822 12.2857H10.4465C10.3739 12.2857 10.3111 12.2592 10.2581 12.2062C10.2051 12.1532 10.1786 12.0904 10.1786 12.0179V11.4821C10.1786 11.4096 10.2051 11.3468 10.2581 11.2938C10.3111 11.2408 10.3739 11.2143 10.4465 11.2143H10.9822C11.0547 11.2143 11.1175 11.2408 11.1705 11.2938C11.2235 11.3468 11.25 11.4096 11.25 11.4821ZM9.10718 9.33929V9.875C9.10718 9.94754 9.08067 10.0103 9.02766 10.0633C8.97464 10.1164 8.91186 10.1429 8.83932 10.1429H8.30361C8.23106 10.1429 8.16828 10.1164 8.11527 10.0633C8.06225 10.0103 8.03575 9.94754 8.03575 9.875V9.33929C8.03575 9.26674 8.06225 9.20396 8.11527 9.15095C8.16828 9.09793 8.23106 9.07143 8.30361 9.07143H8.83932C8.91186 9.07143 8.97464 9.09793 9.02766 9.15095C9.08067 9.20396 9.10718 9.26674 9.10718 9.33929ZM6.96432 7.19643V7.73214C6.96432 7.80469 6.93781 7.86747 6.8848 7.92048C6.83179 7.97349 6.76901 8 6.69646 8H6.16075C6.0882 8 6.02542 7.97349 5.97241 7.92048C5.9194 7.86747 5.89289 7.80469 5.89289 7.73214V7.19643C5.89289 7.12388 5.9194 7.0611 5.97241 7.00809C6.02542 6.95508 6.0882 6.92857 6.16075 6.92857H6.69646C6.76901 6.92857 6.83179 6.95508 6.8848 7.00809C6.93781 7.0611 6.96432 7.12388 6.96432 7.19643ZM4.82146 5.05357V5.58929C4.82146 5.66183 4.79496 5.72461 4.74194 5.77762C4.68893 5.83064 4.62615 5.85714 4.55361 5.85714H4.01789C3.94535 5.85714 3.88257 5.83064 3.82955 5.77762C3.77654 5.72461 3.75003 5.66183 3.75003 5.58929V5.05357C3.75003 4.98103 3.77654 4.91825 3.82955 4.86523C3.88257 4.81222 3.94535 4.78571 4.01789 4.78571H4.55361C4.62615 4.78571 4.68893 4.81222 4.74194 4.86523C4.79496 4.91825 4.82146 4.98103 4.82146 5.05357ZM11.25 9.33929V9.875C11.25 9.94754 11.2235 10.0103 11.1705 10.0633C11.1175 10.1164 11.0547 10.1429 10.9822 10.1429H10.4465C10.3739 10.1429 10.3111 10.1164 10.2581 10.0633C10.2051 10.0103 10.1786 9.94754 10.1786 9.875V9.33929C10.1786 9.26674 10.2051 9.20396 10.2581 9.15095C10.3111 9.09793 10.3739 9.07143 10.4465 9.07143H10.9822C11.0547 9.07143 11.1175 9.09793 11.1705 9.15095C11.2235 9.20396 11.25 9.26674 11.25 9.33929ZM9.10718 7.19643V7.73214C9.10718 7.80469 9.08067 7.86747 9.02766 7.92048C8.97464 7.97349 8.91186 8 8.83932 8H8.30361C8.23106 8 8.16828 7.97349 8.11527 7.92048C8.06225 7.86747 8.03575 7.80469 8.03575 7.73214V7.19643C8.03575 7.12388 8.06225 7.0611 8.11527 7.00809C8.16828 6.95508 8.23106 6.92857 8.30361 6.92857H8.83932C8.91186 6.92857 8.97464 6.95508 9.02766 7.00809C9.08067 7.0611 9.10718 7.12388 9.10718 7.19643ZM6.96432 5.05357V5.58929C6.96432 5.66183 6.93781 5.72461 6.8848 5.77762C6.83179 5.83064 6.76901 5.85714 6.69646 5.85714H6.16075C6.0882 5.85714 6.02542 5.83064 5.97241 5.77762C5.9194 5.72461 5.89289 5.66183 5.89289 5.58929V5.05357C5.89289 4.98103 5.9194 4.91825 5.97241 4.86523C6.02542 4.81222 6.0882 4.78571 6.16075 4.78571H6.69646C6.76901 4.78571 6.83179 4.81222 6.8848 4.86523C6.93781 4.91825 6.96432 4.98103 6.96432 5.05357ZM4.82146 2.91071V3.44643C4.82146 3.51897 4.79496 3.58175 4.74194 3.63477C4.68893 3.68778 4.62615 3.71429 4.55361 3.71429H4.01789C3.94535 3.71429 3.88257 3.68778 3.82955 3.63477C3.77654 3.58175 3.75003 3.51897 3.75003 3.44643V2.91071C3.75003 2.83817 3.77654 2.77539 3.82955 2.72238C3.88257 2.66936 3.94535 2.64286 4.01789 2.64286H4.55361C4.62615 2.64286 4.68893 2.66936 4.74194 2.72238C4.79496 2.77539 4.82146 2.83817 4.82146 2.91071ZM11.25 7.19643V7.73214C11.25 7.80469 11.2235 7.86747 11.1705 7.92048C11.1175 7.97349 11.0547 8 10.9822 8H10.4465C10.3739 8 10.3111 7.97349 10.2581 7.92048C10.2051 7.86747 10.1786 7.80469 10.1786 7.73214V7.19643C10.1786 7.12388 10.2051 7.0611 10.2581 7.00809C10.3111 6.95508 10.3739 6.92857 10.4465 6.92857H10.9822C11.0547 6.92857 11.1175 6.95508 11.1705 7.00809C11.2235 7.0611 11.25 7.12388 11.25 7.19643ZM9.10718 5.05357V5.58929C9.10718 5.66183 9.08067 5.72461 9.02766 5.77762C8.97464 5.83064 8.91186 5.85714 8.83932 5.85714H8.30361C8.23106 5.85714 8.16828 5.83064 8.11527 5.77762C8.06225 5.72461 8.03575 5.66183 8.03575 5.58929V5.05357C8.03575 4.98103 8.06225 4.91825 8.11527 4.86523C8.16828 4.81222 8.23106 4.78571 8.30361 4.78571H8.83932C8.91186 4.78571 8.97464 4.81222 9.02766 4.86523C9.08067 4.91825 9.10718 4.98103 9.10718 5.05357ZM6.96432 2.91071V3.44643C6.96432 3.51897 6.93781 3.58175 6.8848 3.63477C6.83179 3.68778 6.76901 3.71429 6.69646 3.71429H6.16075C6.0882 3.71429 6.02542 3.68778 5.97241 3.63477C5.9194 3.58175 5.89289 3.51897 5.89289 3.44643V2.91071C5.89289 2.83817 5.9194 2.77539 5.97241 2.72238C6.02542 2.66936 6.0882 2.64286 6.16075 2.64286H6.69646C6.76901 2.64286 6.83179 2.66936 6.8848 2.72238C6.93781 2.77539 6.96432 2.83817 6.96432 2.91071ZM11.25 5.05357V5.58929C11.25 5.66183 11.2235 5.72461 11.1705 5.77762C11.1175 5.83064 11.0547 5.85714 10.9822 5.85714H10.4465C10.3739 5.85714 10.3111 5.83064 10.2581 5.77762C10.2051 5.72461 10.1786 5.66183 10.1786 5.58929V5.05357C10.1786 4.98103 10.2051 4.91825 10.2581 4.86523C10.3111 4.81222 10.3739 4.78571 10.4465 4.78571H10.9822C11.0547 4.78571 11.1175 4.81222 11.1705 4.86523C11.2235 4.91825 11.25 4.98103 11.25 5.05357ZM9.10718 2.91071V3.44643C9.10718 3.51897 9.08067 3.58175 9.02766 3.63477C8.97464 3.68778 8.91186 3.71429 8.83932 3.71429H8.30361C8.23106 3.71429 8.16828 3.68778 8.11527 3.63477C8.06225 3.58175 8.03575 3.51897 8.03575 3.44643V2.91071C8.03575 2.83817 8.06225 2.77539 8.11527 2.72238C8.16828 2.66936 8.23106 2.64286 8.30361 2.64286H8.83932C8.91186 2.64286 8.97464 2.66936 9.02766 2.72238C9.08067 2.77539 9.10718 2.83817 9.10718 2.91071ZM11.25 2.91071V3.44643C11.25 3.51897 11.2235 3.58175 11.1705 3.63477C11.1175 3.68778 11.0547 3.71429 10.9822 3.71429H10.4465C10.3739 3.71429 10.3111 3.68778 10.2581 3.63477C10.2051 3.58175 10.1786 3.51897 10.1786 3.44643V2.91071C10.1786 2.83817 10.2051 2.77539 10.2581 2.72238C10.3111 2.66936 10.3739 2.64286 10.4465 2.64286H10.9822C11.0547 2.64286 11.1175 2.66936 11.1705 2.72238C11.2235 2.77539 11.25 2.83817 11.25 2.91071ZM9.10718 14.4286H12.3215V1.57143H2.67861V14.4286H5.89289V12.5536C5.89289 12.481 5.9194 12.4182 5.97241 12.3652C6.02542 12.3122 6.0882 12.2857 6.16075 12.2857H8.83932C8.91186 12.2857 8.97464 12.3122 9.02766 12.3652C9.08067 12.4182 9.10718 12.481 9.10718 12.5536V14.4286ZM13.3929 1.03571V14.9643C13.3929 15.1094 13.3399 15.2349 13.2339 15.341C13.1278 15.447 13.0023 15.5 12.8572 15.5H2.14289C1.9978 15.5 1.87224 15.447 1.76622 15.341C1.66019 15.2349 1.60718 15.1094 1.60718 14.9643V1.03571C1.60718 0.890625 1.66019 0.765067 1.76622 0.65904C1.87224 0.553013 1.9978 0.5 2.14289 0.5H12.8572C13.0023 0.5 13.1278 0.553013 13.2339 0.65904C13.3399 0.765067 13.3929 0.890625 13.3929 1.03571Z" fill="#3ACA2E"/>
</g>
<defs>
<clipPath id="clip0_2658_19252">
<rect width="15" height="15" fill="white" transform="translate(0 0.5)"/>
</clipPath>
</defs>
                      </svg>

                      <span className="text-primary font-semibold text-sm">Visit Campus</span>
                    </button>
                    <button onClick={() => handleDetailClick(college)}  className="flex-1 flex items-center justify-center space-x-2 py-3">
                        <svg width="15" height="15" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M11.0375 4.40937L7.65313 1.025C7.47748 0.849134 7.23918 0.750219 6.99062 0.75H1.625C1.37636 0.75 1.1379 0.848772 0.962087 1.02459C0.786272 1.2004 0.6875 1.43886 0.6875 1.6875V3.25C0.6875 3.33288 0.720424 3.41237 0.779029 3.47097C0.837634 3.52958 0.91712 3.5625 1 3.5625C1.08288 3.5625 1.16237 3.52958 1.22097 3.47097C1.27958 3.41237 1.3125 3.33288 1.3125 3.25V1.6875C1.3125 1.60462 1.34542 1.52513 1.40403 1.46653C1.46263 1.40792 1.54212 1.375 1.625 1.375H6.9375V4.1875C6.9375 4.43614 7.03627 4.6746 7.21209 4.85041C7.3879 5.02623 7.62636 5.125 7.875 5.125H10.6875V12.3125C10.6875 12.3954 10.6546 12.4749 10.596 12.5335C10.5374 12.5921 10.4579 12.625 10.375 12.625H1.625C1.54212 12.625 1.46263 12.5921 1.40403 12.5335C1.34542 12.4749 1.3125 12.3954 1.3125 12.3125V4.5C1.3125 4.41712 1.27958 4.33763 1.22097 4.27903C1.16237 4.22042 1.08288 4.1875 1 4.1875C0.91712 4.1875 0.837634 4.22042 0.779029 4.27903C0.720424 4.33763 0.6875 4.41712 0.6875 4.5V12.3125C0.6875 12.5611 0.786272 12.7996 0.962087 12.9754C1.1379 13.1512 1.37636 13.25 1.625 13.25H10.375C10.6236 13.25 10.8621 13.1512 11.0379 12.9754C11.2137 12.7996 11.3125 12.5611 11.3125 12.3125V5.07188C11.3123 4.82332 11.2134 4.58502 11.0375 4.40937Z" fill="#3ACA2E"/>
                      </svg>
                      <span className="text-primary font-semibold text-sm">View Details</span>
                    </button>
                  </div>
                </div>
              </div>

              <div className="h-[38px] border-t border-[#00000040]">
                  <button className="w-full h-full bg-primary text-white text-[14px] font-semibold rounded-b-lg"
                  onClick={() => handleApplyNowClick(college)}>
                  Apply Now
                </button>
              </div>
            </div>
          ))}
        </div>
        )
      ) : ( <div className="max-w-full mx-auto bg-white rounded-lg border border-[#00000040]">
      <div className="overflow-x-auto">
        <div className="min-w-[800px]">
          <div className="flex justify-between px-4 py-3">
            <p className="w-1/5 text-center font-semibold text-sm sm:text-base">Application Number</p>
            <p className="w-1/5 text-center font-semibold text-sm sm:text-base">College Name</p>
            <p className="w-1/5 text-center font-semibold text-sm sm:text-base">Course Name</p>
            <p className="w-1/5 text-center font-semibold text-sm sm:text-base">Applied Date</p>
            {/* <p className="w-1/5 text-center font-semibold text-sm sm:text-base">Status</p> */}
          </div>
          
          <div className="px-8">
            <div className="h-[1px] bg-black/25"></div>
          </div>

          {applicationsLoading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-[#3ACA2E]"></div>
            </div>
          ) : (
            <div className="space-y-4">
              {applications.length === 0 ? (
                <p className="text-gray-500 text-center">No applications found</p>
              ) : (
                applications.map((application) => (
                  <div
                    key={application.id}
              className="flex justify-between px-4 py-3 border-black/10"
                  >
                    <p className="w-1/5 text-center text-sm sm:text-base">{application.id}</p>
                    <p className="w-1/5 text-center text-sm sm:text-base">{application.university_name}</p>
                    <p className="w-1/5 text-center text-sm sm:text-base">{application.course_master_name}</p>
                    <p className="w-1/5 text-center text-sm sm:text-base">
                      {new Date(application.created_on).toLocaleDateString('en-GB')}
                    </p>
                  </div>
                ))
              )}
            </div>
          )}
        </div>
    </div>
    </div>
    

      )}
      {/* Modal for Course Selection */}
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-6 rounded-lg w-1/2">
            <h2 className="text-lg font-semibold">Select Course</h2>
            <select 
              value={selectedCourse} 
              onChange={(e) => setSelectedCourse(e.target.value)} 
              className="border rounded p-2 w-full mt-2"
            >
              <option value="">Select a course</option>
              {courses.length > 0 ? (
                courses.map((course) => (
                  <option key={course.id} value={course.id}>
                    {course.course_master_name}
                  </option>
                ))
              ) : (
                <option value="">No courses available</option>
              )}
            </select>
            <div className="mt-4">
              <button 
                onClick={handleSubmit} 
                className="bg-primary text-white px-4 py-2 rounded"
              >
                Apply
              </button>
              <button 
                onClick={() => setModalOpen(false)} 
                className="ml-2 border px-4 py-2 rounded"
              >
                Cancel
              </button>
            </div>
          </div>
            <ToastContainer 
                  position="top-right"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={false}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
        </div>
      )}
    </div>
  );
};

export default WishlistedColleges;
